import React, { ReactElement, FunctionComponent, ReactNode } from 'react';
import ParagraphRenderer from '../../../components/article-markdown/renderers/paragraph/ParagraphRenderer';
import FramedImageRenderer from '../framed-image-renderer/FramedImageRenderer';
import * as styles from './DivParagraphRenderer.style';

export interface DivParagraphRendererProps {
  children: ReactNode,
}

const DivParagraphRenderer: FunctionComponent<DivParagraphRendererProps> = ({
  children,
}) => {
  // trick for avoiding emitting a <p> with underlying <div> created by FramedImage
  const hasFramedImage = React.Children.toArray(children).find((comp) => (comp as ReactElement).type === FramedImageRenderer);

  return hasFramedImage ? (
    <div
      css={styles.paragraph}
      data-ref="div"
    >
      {children}
    </div>
  ) : (
    <ParagraphRenderer>
      {children}
    </ParagraphRenderer>
  );
};

export default DivParagraphRenderer;
